import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {ConfirmActionDialogComponent} from '../../common/confirm-action-dialog/confirm-action-dialog.component';
import {Installation} from '../../models/Installation';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatTableDataSource} from '@angular/material';
import {PlantStorages} from '../../models/PlantStorages';
import {ThreePL} from '../../models/ThreePL';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {Vendor} from '../../models/Vendor';

@Component({
  styleUrls: ['./create-new-dialog.component.scss'],
  templateUrl: './create-new-dialog.component.html'
})
export class CreateNewDialogComponent implements OnInit {
  public vendor: Vendor;
  public title: string;
  public item: string;
  public buttonTitle: string;
  public installation: Installation;
  public plCompany: ThreePL;
  public insertObject;
  public displayColumns: string[] = ['id', 'storage_location', 'plant', 'actions'];
  public inputPlantStorage: PlantStorages;
  public dataSource = new MatTableDataSource<PlantStorages>();
  public titleInfo: string;
  countries = [];
  selectedCountry: any;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CreateNewDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.item = this.data.type === 0 ? 'κατασκευάστρια' : this.data.type === 1 ? 'εγκατάσταση' : '3PL';
    this.titleInfo = this.data.type === 1 ? 'Στοιχεία εγκατάστασης' : 'Στοιχεία 3PL';
    if (this.data.edit) {
      this.buttonTitle = 'Ενημέρωση';
      this.title = this.data.type === 0 ? 'Ενημέρωση κατασκευάστριας' : this.data.type === 1 ? 'Ενημέρωση εγκατάστασης' : 'Ενημέρωση 3PL';
    } else {
      this.buttonTitle = 'Δημιουργία';
      this.title = this.data.type === 0 ? 'Δημιουργία νέας κατασκευάστριας' : this.data.type === 1 ? 'Δημιουργία νέας εγκατάστασης' : 'Δημιουργία νέας 3PL';
    }
  }

  public async ngOnInit(): Promise<any> {
    this.commonService.tempDialogReference = this.matDialogRef;
    this.data.type === 0 ? this.matDialogRef.updateSize('750px', '400px') : this.matDialogRef.updateSize('850px', '600px');
    if (this.data.edit) {
      if (this.data.type === 0) {
        this.vendor = {
          id: this.data.vendor.vendor_id,
          name: this.data.vendor.vendor_name,
          manufacturer_id: this.data.vendor.manufacturer_id,
          storage_location: this.data.vendor.storage_location,
          plant: this.data.vendor.plant,
          user_id: null
        };
      } else if (this.data.type === 1) {
        this.installation = {
          id: this.data.installation.id,
          customer_name: this.data.installation.customer_name,
          sales_group_id: this.data.installation.sales_group_id,
          city: this.data.installation.city,
          address: this.data.installation.address,
          country_name: this.data.installation.country_name,
          email: this.data.installation.email,
          postal_code: this.data.installation.postal_code,
          phone_number1: this.data.installation.phone_number1,
          vat_number: this.data.installation.vat_number,
          category_id: this.data.installation.category_id,
          plantStorages: this.data.installation.plantStorages,
          user_id: this.data.installation.user_id,
          role_id: this.data.installation.role_id
        };
      } else if (this.data.type === 2) {
        this.plCompany = {
          id: this.data.threePL.id,
          customer_name: this.data.threePL.customer_name,
          sales_group_id: this.data.threePL.sales_group_id,
          city: this.data.threePL.city,
          address: this.data.threePL.address,
          country_name: this.data.threePL.country_name,
          email: this.data.threePL.email,
          postal_code: this.data.threePL.postal_code,
          phone_number1: this.data.threePL.phone_number1,
          vat_number: this.data.threePL.vat_number,
          category_id: this.data.threePL.category_id,
          plantStorages: this.data.threePL.plantStorages,
          user_id: this.data.threePL.user_id,
          role_id: this.data.threePL.role_id
        };
      }
    } else {
      if (this.data.type === 0) {
        this.vendor = {
          id: '',
          name: '',
          manufacturer_id: '',
          storage_location: '',
          plant: '',
          user_id: null
        };
      } else if (this.data.type === 1) {
        this.inputPlantStorage = {
          id: null,
          storage_location: '',
          plant: '',
          is_active: 1
        };
        this.installation = {
          id: 0,
          customer_name: '',
          sales_group_id: '',
          city: '',
          address: '',
          country_name: '',
          email: '',
          postal_code: '',
          phone_number1: '',
          vat_number: '',
          category_id: '',
          plantStorages: [],
          user_id: null,
          role_id: null,
        };
      } else if (this.data.type === 2) {
        this.inputPlantStorage = {
          id: null,
          storage_location: '',
          plant: '',
          is_active: 1
        };
        this.plCompany = {
          id: 0,
          customer_name: '',
          sales_group_id: '',
          city: '',
          address: '',
          country_name: '',
          email: '',
          postal_code: '',
          phone_number1: '',
          vat_number: '',
          category_id: '',
          plantStorages: [],
          user_id: null,
          role_id: null,
        };
      }
    }
    this.insertObject = {};
    this.insertObject = this.data.type === 0 ? this.vendor : this.data.type === 1 ? this.installation : this.plCompany;
    if (this.data.type !== 0) {
      this.dataSource.data = this.insertObject.plantStorages;
    }

    await this.initCountries();
    if (this.data.installation) {
      this.selectedCountry = this.countries.find(country => country.id === this.data.installation.country_id);
    }
    if (this.data.threePL) {
      this.selectedCountry = this.countries.find(country => country.id === this.data.threePL.country_id);
    }
  }

  async initCountries() {
    try {
      this.countries = await this.commonService.getSimpleList(`country`) as [];

      for (const country of this.countries) {
        country.name = country.name.trim();
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  addInputPlantStorage() {
    this.insertObject.plantStorages.push(this.inputPlantStorage);
    this.dataSource.data = this.insertObject.plantStorages;
    this.clearInputPlantStorage();
  }

  canAddStorage() {
    return !(this.inputPlantStorage.plant && this.inputPlantStorage.storage_location);
  }

  clearInputPlantStorage() {
    this.inputPlantStorage = {
      id: null,
      storage_location: '',
      plant: '',
      is_active: 1
    };
  }

  isFormInValid() {
    if (this.data.type === 0) {
      return this.insertObject.id === '' ||
        this.insertObject.name === '' ||
        this.insertObject.manufacturer_id === '' ||
        this.insertObject.storage_location === '' ||
        this.insertObject.plant === '';
    } else {
      if (this.data.edit) {
        return this.insertObject.customer_name === '' ||
          this.insertObject.city === '' ||
          this.insertObject.address === '' ||
          this.insertObject.country_name === '' ||
          this.insertObject.email === '' ||
          this.insertObject.postal_code === '' ||
          this.insertObject.phone_number1 === '' ||
          this.insertObject.vat_number === '';
      } else {
        return this.insertObject.customer_name === '' ||
          this.insertObject.city === '' ||
          this.insertObject.address === '' ||
          this.insertObject.country_name === '' ||
          this.insertObject.email === '' ||
          this.insertObject.postal_code === '' ||
          this.insertObject.phone_number1 === '' ||
          this.insertObject.vat_number === '' ||
          this.insertObject.plantStorages.length === 0;
      }
    }
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  async submitForm(object: any) {
    try {
      if (object.edit) {
        object.insertObject.action = 'update';

        if (object.type === 0) {
          await this.commonService.updateObject('vendors', object.insertObject);
        } else {
          const model = {
            id: object.insertObject.id,
            customer_name: object.insertObject.customer_name,
            address: object.insertObject.address,
            postal_code: object.insertObject.postal,
            city: object.insertObject.city,
            phone_number1: object.insertObject.phone_number,
            email: object.insertObject.email,
            vat_number: object.insertObject.vat_number,
            vat_number_country: object.insertObject.vat_number_country,
            country_id: object.insertObject.country_id,
            sales_group_id: object.insertObject.sales_group_id,
            user_id: object.insertObject.user_id,
            role_id: object.insertObject.role_id,
            category_id: object.insertObject.category_id,
            action: 'update'
          };
          await this.commonService.updateObject('sale_point/distribution_center', object.insertObject);
        }
      } else {
        if (object.type === 0) {
          await this.commonService.insertObject('vendors', object.insertObject);
        } else {
          object.insertObject.id = null;
          object.insertObject.vat_number_country = null;
          object.insertObject.country_id = object.insertObject.country_id;
          object.insertObject.category_id = object.type === 1 ? 2 : 3;
          object.insertObject.sales_group_id = null;
          await this.commonService.insertObject('sale_point/distribution_center', object.insertObject);
        }
      }
    } catch (e) {
    } finally {
      this.commonService.tempDialogReference.close(object.insertObject);
    }
  }

  async confirmSubmission() {
    const item = this.item === 'κατασκευάστρια' ? 'κατασκευάστριας' : this.item === 'εγκατάσταση' ? 'εγκατάστασης' : this.item;
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.submitForm({type: this.data.type, edit: this.data.edit, insertObject: this.insertObject});
        },
        message: this.data.edit ? `Είστε σίγουροι ότι θέλετε να ενημερώσετε την ${this.item}?` : `Είστε σίγουροι ότι θέλετε να ολοκληρώσετε την δημιουργία ${item}?`,
        title: this.data.edit ? 'Ενημέρωση' : 'Δημιουργία'
      }
    });
  }

  removeStorageFromList(position: number, element: any) {
    this.insertObject.plantStorages.splice(position, 1);
    this.dataSource.data = this.insertObject.plantStorages;
  }

  setCountry() {
    this.insertObject.country_name = this.selectedCountry.name;
    this.insertObject.country_id = this.selectedCountry.id;
  }
}
